/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_NeededInputs */

const en_plan_card_needed = /** @type {(inputs: Plan_Card_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a card to keep your plan.`)
};

const es_plan_card_needed = /** @type {(inputs: Plan_Card_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una tarjeta para mantener tu plan.`)
};

/**
* | output |
* | --- |
* | "Add a card to keep your plan." |
*
* @param {Plan_Card_NeededInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_card_needed = /** @type {((inputs?: Plan_Card_NeededInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_NeededInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_card_needed(inputs)
	return en_plan_card_needed(inputs)
});